import { process } from '@progress/kendo-data-query';
import {
  Dispatch,
  MouseEvent as ReactMouseEvent,
  SetStateAction,
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';

import { Button, DropDownButton } from '@progress/kendo-react-buttons';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { Grid, GridCellProps, GridColumn, GridPageChangeEvent, GridToolbar } from '@progress/kendo-react-grid';
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from '@progress/kendo-react-layout';
import { GridPDFExport } from '@progress/kendo-react-pdf';
import { format, parse } from 'date-fns';
import React from 'react';
import { CSVLink } from 'react-csv';
import SessionStorageService from '../../services/SessionStorageService';
import { GetUserNameTecnico, _export, _exportPdf, b64toBlob, exportPDFWithMethod, formatCurrency, get, handleDownload, handleGenericError, hasPermission, post, setAcaoSelected, setCoordenadasPoligono, setExcelExport, setIntervencaoSelected, setModeloSelected, setPdfExport } from '../../services/utils';
import styles from '../../styles/intervencao/Intervencao.module.scss'
import { AUTH_LOCALSTORAGE, CONSULTAR_ACAO, CURRENT_TIMEZONE, GET_DOCUMENTO, GET_DOCUMENTO_BY_ACAO, GET_DOCUMENTO_BY_INTERVENCAO, GET_INT_ACAO_SHAPEFILE, GET_LIST_RESULTS_ACAO_INTERVENCAO, GET_LIST_RESULTS_EXECUCOES, GET_LIST_RESULTS_INDICADORES, GET_LIST_RESULTS_INDICADORES_ACOES, GET_LIST_RESULTS_INTERVENCAO_ACAO, GET_LIST_RESULTS_INT_ACAO, GET_LIST_RESULTS_RESUMO_EXECUCOES, INT_ACAO_POINT_NAME, LAYER_INDEX_INT_ACAO, OPERATIONAL_LAYER, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA, PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO, PESQUISAR_ACAO, PESQUISAR_DOCUMENTOS_INTERVENCAO, PESQUISAR_INTERVENCAO,RECORDS_LIMIT,RELATORIO_MERGE_ACAO,URL_AJUDA_INTERVENCOES_ACAO, clearLayers } from '../../utils/constants';
import { ResultadoIntervencaoCommandGridCell } from './ResultadoIntervencaoCommandGridCell';
import { useIntervencaoStore } from '../../stores/intervencao';
import { useAcaoStore } from '../../stores/acao';
import { ResultadoAcaoCommandGridCell } from './ResultadoAcaoCommandGridCell';
import { useCommonStore } from '../../stores/common';
import commonStyles from '../../styles/common/Common.module.scss'
import clsx from 'clsx';
import MaximizeButton from '../common/MaximizeButton';
import { ResultadoDocumentoCommandGridCell } from '../documentos/ResultadoDocumentoCommandGridCell';
import { Dialog } from '@progress/kendo-react-dialogs';
import ImagePreviewV2 from '../viewer/ImagePreviewV2'
import VisualizadorColunas from '../Generico/VisualizadorColunas ';
import useVisibleColumns, { Key } from '../../hooks/useVIsibleColumns';
import ReactGA from 'react-ga4';
import { elementoClickMais, itemRenderMais, mostraFloatingMenu_e_Mapa, ocultaFloatingMenu_e_Mapa, telaMobile } from '../common/ItemRenderMais';
import useClearMap from '../../hooks/useClearMap';
import moment from 'moment';
import { base64ApaImage, base64FooterImages, base64SiarlImage } from '../../routes/Base64Images';

type Props = {
  onCloseClick?: (
    e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
  ) => void,
  setShowResultadoAcao: Dispatch<SetStateAction<boolean>>
  setShowRegistarAcao: Dispatch<SetStateAction<boolean>>,
  columns: any,
  setColumns: any,
  columnsPrint: any,
  setColumnsPrint: any,
  columnsDocuments: any,
  setColumnsDocuments: any
}

const options = [
  {
    key: 'ExportarFichasResultados',
    text: 'Exportar fichas resultados',
    icon: <span className={`icon-siarl icon-exportar ${styles.btnImprimir}`}></span>,
  }
]
type PageState = {
  skip: number
  take: number
}
const initialDataState: PageState = { skip: 0, take: 20 }

const keyPainelPrincipal:Key = 'acaoColunasVisiveis';
const keyPainelDocumentos:Key = 'acaoDocumentosColunasVisiveis';

export default function ResultadoAcaoForm({
  onCloseClick,
  setShowResultadoAcao,
  setShowRegistarAcao,
  columns,
  setColumns,
  columnsPrint,
  setColumnsPrint,
  columnsDocuments,
  setColumnsDocuments
}: Props) {
  const [isMobile, setIsMobile] = useState(false);
  const [acoes, setacoes] = useState([])
  const [documentosacoes, setDocumentosacoes] = useState([])

  const [selected, setSelected] = useState<number>(0)
  const [page, setPage] = useState<PageState>(initialDataState)
  const [urlDoDocumento, setUrlDoDocumento] = useState("");
  const [idDoDocumento, setIdDoDocumento] = useState("");
  const [openForm, setOpenForm] = useState<boolean>(false)

  const isCurrentViewMaximized = useCommonStore(state => state.isCurrentViewMaximized)

  const selectAcaoResult = useAcaoStore(
    (state) => state.selectAcaoResult
  )
  const selectAcaoResultId = useAcaoStore(
    (state) => state.selectAcaoResultId
  )
  const [pageSizeValue, setPageSizeValue] = useState<
    number | string | undefined
  >()

  const getAcao = async (data: any) =>
    await get<any, any>(`${PESQUISAR_ACAO}/` + data)

      const getDocumentosByAcaoIDs = async (data: any) =>
  await post<any, any>(`${GET_DOCUMENTO_BY_ACAO}` , data)
  const getDocumento = async (data: any) =>
    await get<any, any>(`${GET_DOCUMENTO}/` + data)
  const getShapeFile = async (data: any) =>
  await post<any, any>(`${GET_INT_ACAO_SHAPEFILE}`, data)

  
  const getAcaoPorIds = async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_INT_ACAO}`, data)

  const getAcaoIntervencao = async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_ACAO_INTERVENCAO}`, data)
  
  const getIndicadoresAcaoPorIds = async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_INDICADORES_ACOES}`, data)

  const getExecucoesPorIds = async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_EXECUCOES}`, data)

  const getResumoExecucoesPorIds = async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_RESUMO_EXECUCOES}`, data)
  
  const relatorioAcaoMerge = async (data: any) =>
    await post<any, any>(`${RELATORIO_MERGE_ACAO}`, data)

    const documentosToPreview = documentosacoes
     const handleMessageEvent = useCallback((event: MessageEvent) => {
        if (event.data.type == "resultadoAcaoPesquisaChange") {
            SessionStorageService.setItem("resultadoAcaoPesquisa", event.data.value);
        }
    }, [])

     useEffect(() => {
        window.addEventListener(
            'message',
            handleMessageEvent,
            false
        )

        return () => {
            window.removeEventListener(
                'message',
                handleMessageEvent,
                false
            )
        }
    }, [handleMessageEvent])
  const {getVisibleColumns, removeColumnsKeys} = useVisibleColumns();

  const PageTemplate = (props: any) => (
    <div className="page-template">
       <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '10px', padding: '10px' }}>
      
       <div>
       <img style={{ width: '128px', height: 'auto', marginLeft: '2px' }} src={base64SiarlImage} alt="SIARL Logo" />
       </div>
       <div style={{ textAlign: 'right' }}>
         <span style={{ fontSize: '18px', color: '#1ba49c' }}>PESQUISA DE AÇÕES</span>
       </div>
     </div>
     <div className="footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '10px' }}>
        
       <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
         <img style={{ width: '105px', marginBottom: '-25px' }} src={base64ApaImage} alt="APA Logo" />
         <img style={{ width: '280px', height: 'auto', marginBottom: '-25px' }} src={base64FooterImages} alt="Footer Image" />
       </div>
      
       <div style={{ flex: 1, textAlign: 'right', marginBottom: '-25px' }}>
        Data : {format(new Date(), "dd/MM/yyyy")} | Página {props.pageNum} de {props.totalPages}
       </div>
     </div>
   </div>
  );

 
  const consultarAcao = async (data: any) => await post<any, any>(`${CONSULTAR_ACAO}`, data)
  
  const initialized = useRef(false)
    useEffect(() => {
        if (!initialized.current) {
          initialized.current = true;    
          if (SessionStorageService.getItem("lastSearchAcao") && !SessionStorageService.getItem("firstCallAcao")) {
      postMessage({ type: "showLoader" }, "*");
      const objToSearch = SessionStorageService.getItem("lastSearchAcao") ?? '';
      consultarAcao(objToSearch).then((data) => {
        SessionStorageService.setItem("resultadoAcaoPesquisa", data);
        setResultsAcao();
         postMessage({ type: "hideLoader" }, "*");

      })
    } 
    else {
      setResultsAcao();
  }
}
  }, [])

  const setResultsAcao = () => {
        const results = typeof SessionStorageService.getItem('resultadoAcaoPesquisa') === 'string' ? JSON.parse(SessionStorageService.getItem('resultadoAcaoPesquisa')) : SessionStorageService.getItem('resultadoAcaoPesquisa');

        const formattedResults = results.map((item: any) => ({
          ...item,
          inv_previsto: formatCurrency(item.inv_previs),
          val_contrat: formatCurrency(item.val_contrat),
          valor_por_executar: formatCurrency(item.valor_por_executar),
          inv_realizado: formatCurrency(item.inv_realizado),
          revisao_precos: formatCurrency(item.revisao_precos),
        }));
    

        setacoes(formattedResults)
        const iframe: any = document.getElementById('iframeGeoPortal')
        const ids: any[] = []
        results.forEach((item: any) => {
          ids.push(item.id)
          })
          iframe.contentWindow?.postMessage(
            { type: 'SiarlDefineExtraLayerTooltipColumns', value:
              { layer: INT_ACAO_POINT_NAME,  columns: columns.columns.filter((x: any) => x.show).map((option: { field: any; title: any; }) => ({
           field: option.field,
           title: option.title
         })) } },
            '*'
          )

          iframe.contentWindow?.postMessage(
            { type: 'SiarlIntAcaoSearch', value:{ ids : ids, result: results} },
            '*'
          )

          getVisibleColumns(keyPainelPrincipal, setColumns)
        postMessage({ type: 'hideLoader' }, '*');

    }

    useEffect(() => {
      const iframe: any = document.getElementById('iframeGeoPortal')
      const ids: number[] = []
      acoes.forEach((element: any) => {
        ids.push(element.id)
      })
      iframe.contentWindow?.postMessage(
        { type: 'SiarlIntAcaoSearch', value: ids },
        '*'
      )
    }, [])
   
  const [clearMap] = useClearMap();

  const clearSearchResults = () => {
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage({ type: "SiarlIntAcaoClearLayers", value: "true" }, '*')
    SessionStorageService.removeItem('resultadoAcaoPesquisa')
    removeColumnsKeys(keyPainelDocumentos)
    removeColumnsKeys(keyPainelPrincipal)
    setCoordenadasPoligono(undefined);
    clearMap(clearLayers["CLEAR_LAYERS_ACAO"])
    SessionStorageService.removeItem("lastSearchAcao");
    //postMessage({ type: "form", value: "pesquisarAcao" }, "*");
    postMessage({type: "clearSearchResultsAcao"}, "*");
    setacoes([]);
  }

  useEffect(() => {
    SessionStorageService.setItem("selectedAcao", 0);
  }, [])

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected)
    postMessage({type: "subSelectedIntervencaoChange", value: e.selected}, "*");
  }
  const handlePageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent
    const take = event.page.take

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value)
    }

    setPage({
      ...event.page,
      take,
    })
  }

  useEffect(() => {

    try {

      const results =  typeof SessionStorageService.getItem('resultadoAcaoPesquisa') === 'string' ? JSON.parse(SessionStorageService.getItem('resultadoAcaoPesquisa')) : SessionStorageService.getItem('resultadoAcaoPesquisa');
      

      const formattedResults = results.map((item: any) => ({
        ...item,
        inv_previs: formatCurrency(item.inv_previs),
        val_contrat: formatCurrency(item.val_contrat),
        valor_por_executar: formatCurrency(item.valor_por_executar),
        inv_realizado: formatCurrency(item.inv_realizado),
        revisao_precos: formatCurrency(item.revisao_precos),
      }));
  

      setacoes(formattedResults)
      try {
        const idsAcao = results?.map((o: any) => o.id);

        const iframe: any = document.getElementById('iframeGeoPortal');
        iframe.contentWindow?.postMessage({ type: "SiarlIntAcaoSearch", value: idsAcao }, '*');

        getDocumentosByAcaoIDs(idsAcao).then(response => {
          setDocumentosacoes(response)
          console.log(response)
        })

      } catch (error) {
        console.error('Erro ao buscar os dados:', error)
      }

    } catch (e) {
      setacoes([]);
    }

  }, [])

  const handleLocationClickById = (acaoLocal: Record<string, any>) => async () => { 
    const id = acaoLocal.int_acao_id ?? acaoLocal.id;
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage({ type: "SiarlIntAcaoCenter", value: [id] }, '*')
  }

  const handleInfoClickById = (acaoLocal: Record<string, any>) => async () => {

     const id = acaoLocal.int_acao_id ?? acaoLocal.id;
     const acao = await getAcao(id);
     const tecnico = await GetUserNameTecnico(acao.utilizador_id);

     if (!acao) {
      postMessage({type: "infoMsg", value: { message: "Registo desativado" }}, "*");
      return;
    }

    const iframe: any = document.getElementById('iframeGeoPortal')
    const objToShow = {
      ...acao,
      id: acao.id,
      n_processo_aquisitivo: acao.n_processo_aquisitivo ?? undefined,
      n_filedoc: acao.n_filedoc ?? undefined,
      designacao: acao.designacao ?? undefined,
      id_estado: acao.id_estado ?? undefined,
      nuts1: acao.nuts1 ?? undefined,
      nuts2: acao.nuts2 ?? undefined,
      nuts3: acao.nuts3 ?? undefined,
      distrito : acao.distrito ?? undefined,
      concelho: acao.mobilizacao ?? undefined,
      freguesia: acao.freguesia ?? undefined,
      arh: acao.arh ?? undefined,
      capitania : acao.capitania ?? undefined,
      massaagua: acao.massaagua ?? undefined,


      data_ini_p : acao.data_ini_p?new Date(acao?.data_ini_p):null,
      data_con_p : acao.data_con_p?new Date(acao?.data_con_p):null,
      data_ini_e : acao.data_ini_e?new Date(acao?.data_ini_e):null,
      data_con_e : acao.data_con_e?new Date(acao?.data_con_e):null,
      id_tipo_n1: acao?.tipo_n1 ?? undefined,
      id_tipo_n2: acao?.tipo_n2 ?? undefined,
      id_tipo_n3: acao?.tipo_n3 ?? undefined,
      id_tipo_n4: acao?.tipo_n4 ?? undefined,


      entidade : acao.diEntidade ?? undefined,
      tipo_engenharia : acao.acaoTipEngenharia ?? undefined,
      id_natureza_acao : acao.acao_natureza ?? undefined,
      id_int_acao_componente : acao.int_acao_componente ?? undefined,
      id_int_acao_planeamento: acao.int_acao_planeamento ?? undefined,
      comunitario : acao.comunitario ?? undefined,
      nacional : acao.nacional ?? undefined,
      numero_candidatura : acao.numero_candidatura ?? undefined,
      designacao_candidatura : acao.designacao_candidatura ?? undefined,
      inv_previs : acao.inv_previs ?? undefined,
      val_contrat : acao.val_contrat ?? undefined,
      inv_realizado : acao.inv_realizado ?? undefined,
      revisao_precos : acao.revisao_precos ?? undefined,
      local: acao.local ?? undefined,
      utilizador_id: tecnico,
      taxa_execucao : acao.taxa_execucao ?? undefined,
      valor_por_executar : acao.valor_por_executar ?? undefined,
      data_adjudicacao : acao.data_adjudicacao?new Date(acao?.data_adjudicacao):null,
      data_artigo : acao.data_artigo?new Date(acao?.data_artigo):null,
      data_tutela : acao.data_tutela?new Date(acao?.data_tutela):null,
      data_tc : acao.data_tc?new Date(acao?.data_tc):null,
      obs: acao.obs ?? undefined,
      data_registo: acao.data_registo?new Date(acao?.data_registo):null,
      id_proc_contratacao: acao.proc_contratacao ?? undefined


    }
    sessionStorage.setItem('novaAcao', 'false')
    selectAcaoResult(objToShow)
    setAcaoSelected(objToShow);
    setShowResultadoAcao(false)
    setShowRegistarAcao(true)
    postMessage({type:"form", value : "registarAcao"}, "*");
    SessionStorageService.removeItem("dataAcaoExecucao")
    SessionStorageService.setItem("valor_contratado", acao.val_contrat)
    const idToSend = [acao?.id];

    iframe.contentWindow?.postMessage({ type: "SiarlIntAcaoSearch", value: idToSend }, '*')


    iframe.contentWindow?.postMessage({ type: "SiarlIntAcaoCenter", value: idToSend }, '*')
  }
  
  const acaoCustomCell = (props: GridCellProps) => (
    <ResultadoAcaoCommandGridCell
      {...props}
      onInfoClick={handleInfoClickById}
      onLocationClick={handleLocationClickById}
      onDocumentPreviewClick={handleDocumentPreviewClickById}
      {...conditionalProps}

    />
  )

  const documentoCustomCell = (props: GridCellProps) => (
    <ResultadoDocumentoCommandGridCell
    onLocationMouseEnter={function (documentos: Record<string, unknown>): void {
      throw new Error('Function not implemented.');
    } } onLocationMouseLeave={function (documentos: Record<string, unknown>): void {
      throw new Error('Function not implemented.');
    } } {...props}
    onDocumentPreviewClick={handleDocumentPreviewClickById} />  )

  const handleDocumentPreviewClickById = (documentosLocal: Record<string, any>) => async () => {

    try {

      postMessage({ type: "showLoader" }, "*");
      const documentos = await getDocumento(documentosLocal.id);

      setIdDoDocumento(documentosLocal.id);
      setUrlDoDocumento(documentos.url);
      setOpenForm(true);

    } catch (error) {
      handleGenericError(error, "Não foi possivel abrir o documento!")
      setOpenForm(false);

    } finally {

      postMessage({ type: "hideLoader" }, "*");

    }
  }

  const nextPhoto = async (e: any) => {

    try{

      postMessage({ type: "showLoader" }, "*");
      const nextIds = documentosToPreview
        .filter((doc: any) => doc.id < idDoDocumento && doc.url !== '')
        .map((doc: any) => doc.id);
  
      if (nextIds.length > 0) {
        const nextId = Math.max(...nextIds);
        console.log(`O próximo ID é ${nextId}`);
  
        const documento = await getDocumento(nextId);
  
        setIdDoDocumento(nextId.toString());
        setUrlDoDocumento(documento.url);

        const iframe: any = document.getElementById('iframeGeoPortal')
        
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlIntAcaoHighlight',
            value: [e.int_acao_id],
          },
          '*'
        )
  
      } else {
        console.log("Não há um próximo ID na lista.");
      }

    }catch(error){

      postMessage({ type: "errorMsg", value: "Não foi possivel abrir o documento!" }, "*");

    }finally{

      postMessage({ type: "hideLoader" }, "*");

      e.preventDefault();
    }
   
  }


  const previousPhoto = async (e: any) => {

    try{

      postMessage({ type: "showLoader" }, "*");
      const previousIds = documentosToPreview
        .filter((doc: any) => doc.id > idDoDocumento && doc.url !== '')
        .map((doc: any) => doc.id);
  
      if (previousIds.length > 0) {
        const previousId = Math.min(...previousIds);
        console.log(`O anterior ID é ${previousId}`);
  
        const documento = await getDocumento(previousId);
  
        setIdDoDocumento(previousId.toString());
        setUrlDoDocumento(documento.url);

        const iframe: any = document.getElementById('iframeGeoPortal')
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlIntAcaoHighlight',
            value: [e.int_acao_id],
          },
          '*'
        )
      } else {
        console.log("Não há um anterior ID na lista.");
      }

    }catch(error){

      handleGenericError(error, "Não foi possivel abrir o documento!")

    }finally{

      postMessage({ type: "hideLoader" }, "*");

      e.preventDefault();
    }
       
  }

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/ResultadoIntAcao" });
  }, []);

  useEffect(() => {

    const elemento: any = document.querySelector(".k-window-content.k-dialog-content");

    if (elemento) {
      elemento.style.padding = "0px";
    }

  }, [openForm]);

  const close = () => {
    setOpenForm(false);
  }

  const [dataState, setDataState] = React.useState({
    skip: 0,
    take: 20,
    sort: [],
    group: [],
  });

  const [dataStateDocumentos, setDataStateDocumentos] = React.useState({
    skip: 0,
    take: 20,
    sort: [],
    group: [],
  });

  const dataStateChange = (event: any) => {
    setDataResult(process(acoes, event.dataState));
    setDataState(event.dataState);
  };

  const [dataResult, setDataResult] = React.useState(
    process(acoes, dataState)
  );

  const dataStateChangeDocumentos = (event: any) => {
    setDataResultDocumentos(process(documentosacoes, event.dataState));
    setDataStateDocumentos(event.dataState);
  };

  const [dataResultDocumentos, setDataResultDocumentos] = React.useState(
    process(documentosacoes, dataStateDocumentos)
  );

  const optionsImprimir = [
    {
      key: 'ExportarListaResultados',
      text: 'Resultados',
    },
  ]

  const optionsExportar = [
    {
      key: 'ExportarListaResultadosExcel',
      text: 'excel',
    },
    {
      key: 'ExportarListaResultadosShapeFile',
      text: 'Shapefile',
    },
    {
      key: 'ExportarTodasFichas',
      text: 'Fichas',
    },
  ]

  const itemRender = (props: { item: any; itemIndex: number }) => {
    const isTitleItem = props.item.key === 'titulo';
    if (isTitleItem) {
      // Item de título personalizado
      return (
        <div className={styles.DropDownButtonTitulo}>
          <span>{props.item.text}</span>
        </div>
      );
    } else {
      // Demais itens
      return (
        <div className={styles.DropDownButtonItem}>
          <span>{props.item.text}</span>
        </div>
      );
    }
  };

  const canSeeIntervencao = 
  hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO) ||
  hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO) 
  const completoLeitura =   hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA) 


  const onItemClickExportarFichas = async () => {
    try {
  
    
      const relatorios = [];
  
      const results =  SessionStorageService.getItem('resultadoAcaoPesquisa')
  
      const idsAcao = results.map((o: any) => o.id);
  
      if(idsAcao.length  > RECORDS_LIMIT){
        postMessage({ type: 'errorMsg', value: { message: "Não é possivel exportar mais de 100 fíchas" } }, '*')
        return false
      }
    
     const acoes = await getAcaoPorIds(idsAcao);
     const intervencaoAcao = await getAcaoIntervencao(idsAcao);
     const indicadoresAcao = await getIndicadoresAcaoPorIds(idsAcao);
     const execucoesAcao = await getExecucoesPorIds(idsAcao);
     const resumoExecucoesAcao = await getResumoExecucoesPorIds(idsAcao);
      
        postMessage({ type: 'showLoader' }, '*');
      
        for (const acaoId of idsAcao) {
  
        const acao = acoes.find((acao: any) => acao.id === acaoId);
  
        const objToSendImgMapa : any = {
          CodPrintTemplate: "RELATORIO_INT_ACAO",
          extendInfo: {
            spatialReference: {
              wkid: 0
            },
            xmin: 0,
            ymin: 0,
            xmax: 0,
            ymax: 0
          },
          ListOperationalLayerInfo: [
            {
              IdOperationLayer: OPERATIONAL_LAYER,
              UseLayerExtent: false,
              DefinitionExpression: "",
              ListServiceLayer: [
                {
                    LayerId: LAYER_INDEX_INT_ACAO,
                    DefinitionExpression: "id=" + acao?.id,
                    UseLayerExtent: true
                }
              ]
            }
          ]
        }

        
      let formattedIntervencaoAcao;
      const filteredIntervencaoAcao = intervencaoAcao.filter((item: any) => item.id_acao === acaoId);
      if (filteredIntervencaoAcao.length > 0) {
 
        formattedIntervencaoAcao = filteredIntervencaoAcao.map((item: any) => ({
        'ID Intervencao': item.id_interv ?? '-',
        'Designacao': item.designacao ?? '-',
        'Código': item.codigo ?? '-',
        'Estado': item.intEstado?.descricao ?? '-',
        'Tipo n3': item.IntPalXXITipNivel3 ? item.IntPalXXITipNivel3.descricao : '-',
        'Percentagem': item.percentagem ?? '-',
      }));
}

   
    let formattedIndicadores;
    const filteredIndicadoresAcao = indicadoresAcao.filter((item: any) => item.id_acao === acaoId);
    if (filteredIndicadoresAcao.length > 0) {

      formattedIndicadores = filteredIndicadoresAcao.map((item: any) => ({
         'Indicador': item.intIndicador?.descricao ?? '-',
          'Valor': item.valor ?? '-'
    }));
    }

    let formattedAcaoExecucao;
    const filteredExecucoes = execucoesAcao.filter((item: any) => item.id_acao === acaoId);
    if (filteredExecucoes.length > 0) {

      formattedAcaoExecucao = filteredExecucoes.map((item: any) => ({
     'Data fatura': item?.data_fatura ? new Date(item.data_fatura).toLocaleString() : '-',
      'Numero fatura': item?.numero_fatura ?? '-',
      'Descricao': item?.descricao ?? '-',
      'Valor total': item?.valor_total ?? '-'
      }));
      }

    let formattedResumoExecucao;
    const filteredResumoExecucoes = resumoExecucoesAcao.filter((item: any) => item.id_acao === acaoId);
    if (filteredResumoExecucoes.length > 0) {

      formattedResumoExecucao = filteredResumoExecucoes.map((item: any) => ({
        'Ano': item?.ano ?? '-',
        'Numero registo': item?.numero_registos ?? '-',
        'Valor': item?.valor ?? '-'
    }));
    }

     
        const relatorio = {
          id: acao?.id,
          dados: {
                //  REGISTO
          'Nº processo APA:': acao?.n_filedoc ?? '',
          'Estado:': acao?.acaoEstado?.descricao ?? '',
          'Data/Hora Registo:': acao?.data_registo ? new Date(acao.data_registo).toLocaleString() : '',
          'Técnico:': acao?.utilizador_id ?? '',
          'Entidade:': acao?.diEntidade?.nome ?? '',

          //  IDENTIFICAÇÃO 
          'Designação:': acao?.designacao ?? '',
          'Nº de processo aquisitivo:': acao?.n_processo_aquisitivo ?? '',
          'Procedimento de contratação:': acao?.id_proc_contratacao?.descricao ?? '',
          'Data da tutela:': acao?.data_tutela ?? '',
          'Data do tribunal de contas:': acao?.data_tc ?? '',
          'Data do artigo:': acao?.data_artigo ?? '',
          'Data prevista início:': acao?.data_ini_p ? new Date(acao?.data_ini_p).toLocaleDateString() : '',  
          'Data prevista conclusão:': acao?.data_con_p ? new Date(acao?.data_con_p).toLocaleDateString() : '',
          'Investimento previsto:': acao?.inv_previs ?? '',
          'Data de adjudicação:': acao?.data_adjudicacao ?? '',
          'Valor do contrato:': acao?.val_contrat ?? '',
          'Taxa de execução:': acao?.taxa_execucao ?? '',
          'Valor por executar:': acao?.valor_por_executar ?? '',
          'Investimento realizado:': acao?.inv_realizado ?? '',
          'Data de início de execução:': acao?.data_ini_e ? new Date(acao?.data_ini_e).toLocaleDateString() : '',
          'Data de conclusão de execução:': acao?.data_con_e ? new Date(acao?.data_con_e).toLocaleDateString() : '',
          'Revisão preços:': acao?.revisao_precos ?? '',

          //  LOCALIZAÇÃO
          'Concelhos:': acao.concelhos ? acao.concelhos : '',
          'ARH:': acao.arhs ? acao?.arhs : '',
          'Capitania:': acao.capitanis? acao?.capitanias : '',
          'Praia:': acao?.praia ? acao?.praia : '',
          'Referência do local:': acao?.local ?? '',

          // 'ENTIDADE REPONSÁVEL' : '',
          'Entidades:': acao?.diEntidade?.nome ?? '',

          'CARACTERIZAÇÃO' : '',
          'Tipologia nível 1:': acao?.tipo_n1?.descricao ?? '',
          'Tipologia nível 2:': acao?.tipo_n2?.descricao ?? '',
          'Tipologia nível 3:':  acao ?.tipo_n3?.descricao ?? '',
          'Tipologia nível 4:': acao?.tipo_n4?.descricao ?? '',
          'Natureza da ação:': acao?.acao_natureza?.descricao ?? '',
          'Componente da ação:': acao?.int_acao_componente?.descricao ?? '',
          'Tipo de planeamento:': acao?.int_acao_planeamento?.descricao ?? '',

          'FONTE FINANCEIRA' : '',
          'Nº de candidatura: ': acao?.numero_candidatura ?? '',
          'Designação de candidatura:': acao?.designacao_candidatura ?? '',

          //INTERVENCAO ACAO
          formattedIntervencaoAcao,
          
          // //INDICADORES DE CONCRETIZACAO
          formattedIndicadores,

          // //EXECUCAO ACAO
          formattedAcaoExecucao,

          // //RESUMO EXECUCAO,
          formattedResumoExecucao

          },     
          img_mapa: "",
          objJsonToCreateImg: objToSendImgMapa
        };
  
        
        relatorios.push(relatorio);
    }
  
      const mergedPdfBase64 = await relatorioAcaoMerge(relatorios);
      if (mergedPdfBase64) {
        const blob = b64toBlob(mergedPdfBase64, 'application/pdf');
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      }
    } catch (error) {
      console.log(error);
      postMessage({ type: 'errorMsg', value: { left: '50%', message: "Verifique os campos obrigatórios." } }, '*');
    } finally {
      postMessage({ type: 'hideLoader' }, '*');
    }
  };

  
  const conditionalProps =  canSeeIntervencao || completoLeitura
  ? { 
      onInfoClick: handleInfoClickById
  } 
  : {};

  const onItemClickExportar = async(event: any) => {


    if (event.item.key == 'ExportarTodasFichas') {

      onItemClickExportarFichas();

    } 
    else if (event.item.key == 'ExportarListaResultadosExcel') {

      exportExcel();

    } else if (event.item.key == 'ExportarListaResultadosPdf') {

      exportPDF();

    } else if (event.item.key == "ExportarListaResultadosShapeFile") {
      const results = SessionStorageService.getItem('resultadoAcaoPesquisa')
      
  
      if (results) {
        const iframe: any = document.getElementById('iframeGeoPortal')
        const ids: number[] = []
        results.forEach((element: any) => {
          ids.push(element.id)
        })

        const file: any = await getShapeFile(ids);
        const filePath = 'shapeFileIntAcao.zip';

        handleDownload(file, filePath);
    } 
  }
};

  const onItemClickImprimirDocumentos = (event: any) => {

    if (event.item.key == 'ExportarListaResultados') {

      const link: HTMLAnchorElement | null = document.querySelector('#print-results-documentos');

      if (link) {
        link.click();
      }

    }

  };


  const options = [
    {
      key: 'ExportarListaResultadosExcel',
      text: 'Excel',
    },
  ]
  
  const exportExcel = () => {
    _export.save();
  };

  const exportPDF = () => {
    _exportPdf.save();
  };

  const [columsDocuments, setColumsDocuments] = useState<{ columns: { field: string, title: string, width: number | string, show: boolean }[] }>({
    columns: [
      { field: "id", width: 70, title: "ID", show: true },
      { field: "filedoc_cod", width: 190, title: "ID Documento Filedoc", show: true },
      { field: "data_publicacao", width: 150, title: "Data publicação", show: true },
      { field: "tipoRecurso.designacao", width: 150, title: "Tipo de recurso", show: true },
      { field: "titulo", width: 90, title: "Título", show: true },
      { field: "autores", width: 90, title: "Autor", show: true },
      { field: "entidade.nome", width: 90, title: "Entidade", show: true },
      { field: "id_estado", width: 'auto', title: "Estado", show: true },
    ]
  })

  useEffect(() => {
    SessionStorageService.setItem(keyPainelPrincipal, JSON.stringify(columns));
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
      { type: 'SiarlDefineExtraLayerTooltipColumns', value:{  layer: INT_ACAO_POINT_NAME,  columns: columns.columns.filter((x: { show: any; }) => x.show).map((option: { field: any; title: any; }) => ({
     field: option.field,
     title: option.title
   })) } },
      '*'
    )

    //postMessage({type: "columnsChangeAcao", value: columns}, "*");
  }, [columns]);

  useLayoutEffect(() => {

    const handleResize = () => {

      if (window.innerWidth <= telaMobile) {
        
        setIsMobile(true);
        ocultaFloatingMenu_e_Mapa();

      }else{

        setIsMobile(false);
        mostraFloatingMenu_e_Mapa();

      }

    };
  
    window.addEventListener('resize', handleResize);
  
    handleResize();
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);  


  const optionsMais = [
    {
      key: 'titulo',
      text: 'Imprimir',
    },
    {
      key: 'imprimirFicha',
      text: 'Resultados',
      className: 'icon-siarl icon-imprimir btnIconRegistar'
    },
    {
      key: 'titulo',
      text: 'Exportar',
    },
    ...optionsExportar.map(option => ({
      ...option,
      className: 'icon-siarl icon-exportar btnIconRegistar',
    })),
  ]

  const handleNewRegistoClick = () => {
      setAcaoSelected(undefined);
      selectAcaoResult(undefined);
      setShowResultadoAcao(false)
      const loggedUser = JSON.parse(
        localStorage.getItem(AUTH_LOCALSTORAGE) ?? '{}'
      )
      setAcaoSelected({ utilizador_id: loggedUser?.user?.name })

      sessionStorage.setItem('novaAcao', 'true')
      if (setShowRegistarAcao) setShowRegistarAcao(true)
  }

  const openAjuda = () => {
    window.open(URL_AJUDA_INTERVENCOES_ACAO, "_blank")
  }

  return (
  <div>
      <div>
        {/* <div>
          <div className={styles.nomeDoModulo}>
            Intervenções
          </div>
          <div className={styles.tituloDaPagina}>
            Resultados de pesquisa
          </div>
        </div> */}

        <div>

          {/* {hasPermission(PERMISSION_INSERIR_INTERVENCAO) && (  
            hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO) ||
            hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO)
            )? 
            <Button
              onClick={handleNewRegistoClick}
              className={styles.btnNovoRegisto}
              style={{ display: isMobile ? 'none' : '' }}
              id='novoRegisto'
              title='Nova ação'
            >
              <span className="icon-siarl icon-registar btnIconRegistar" /> &nbsp;{' '}
              Nova ação
            </Button>
          :  ''} */}



          {/* {isMobile &&
            <DropDownButton
              items={optionsMais}
              className={styles.btnMais}
              iconClass="icon-siarl icon-mais"
              onItemClick={onItemClickMais}
              fillMode={'flat'}
              itemRender={itemRenderMais}
              title="Mais Opções"
            />
          }

          <button onClick={openAjuda} className={styles.btnInfo} title="Obter Ajuda">
              <span className="icon-siarl icon-ajuda"></span>
          </button>
          <button className={styles.btnFechar} onClick={onCloseClick} title="Minimizar">
            <span className="icon-siarl icon-minimizar"></span>
          </button>

          {!isMobile &&
          <MaximizeButton className={styles.btnMaximizar} />
          } */}
        </div>

      </div>

      <TabStrip selected={selected} onSelect={handleSelect} scrollable={isMobile}>
        <TabStripTab title="Registos">
      

          <ExcelExport
            fileName='Resultado_Acoes'
            data={acoes}
            ref={(exporter) => {
              setExcelExport(exporter);
            }}
          >
            <Grid className={styles.formResultadoTabs}
              sortable={true}
              onDataStateChange={dataStateChange}
               data={dataResult.data.length > 0 ? dataResult : acoes?.map((acao:any)=>({
                ...acao, 
                data_ini_p: acao?.data_ini_p ? format(new Date(acao?.data_ini_p), 'dd/MM/yyyy') : '',
                data_con_p: acao?.data_con_p ? format(new Date(acao?.data_con_p), 'dd/MM/yyyy') : '',
                data_ini_e: acao?.data_ini_e ? format(new Date(acao?.data_ini_e), 'dd/MM/yyyy') : '', 
                data_con_e: acao?.data_con_e ? format(new Date(acao?.data_con_e), 'dd/MM/yyyy') : '', 
                data_adjudicacao: acao?.data_adjudicacao ? format(new Date(acao?.data_adjudicacao), 'dd/MM/yyyy') : '', 
              })).slice(page.skip, page.take + page.skip)
            }
            total={acoes.length}
              {...dataState}
              pageable={{
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
              }}
              skip={page.skip}
              take={page.take}
              //groupable={true}
            >
              <GridColumn cell={acaoCustomCell} width={50} />

              {columns?.columns?.map((column: { show: any; field: string | undefined; width: string | number | undefined; title: string | undefined; }, i: React.Key | null | undefined) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} width={column.width} title={column.title} />
              )
            );
          })}
            </Grid>
          </ExcelExport>

          <GridPDFExport  
            fileName='Resultado_Acao'
            paperSize="A4"
            margin={{ top: '3cm', right: '1cm', bottom: '2cm', left: '1cm' }}
            landscape={true}
            pageTemplate={PageTemplate} 
            repeatHeaders={true}
            ref={(exporter) => {
              setPdfExport(exporter)
            }}

          >
            {
              <Grid
                sortable={true}
                 data={acoes}                
                pageable={{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: true,
                  previousNext: true,
                }}
                style={{ borderSpacing: '0' }} 
                //groupable={true}
              >
                {columns?.columns?.map((column: any, i: any) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} filter={column.filter} width={column.width} title={column.title} columnMenu={column.columnMenu}
                headerCell={() => <div className="pdf-header">{column.title}</div>}
                cell={(props: any) => (
                  <td style={{ fontSize: '10px', wordBreak: 'break-word', padding: '5px', border: '1px solid #1ba49c' , lineHeight: '1.3' }}>
                    {props.dataItem[column.field]}
                  </td>
                )}
                />
              )
            );
          })}
              </Grid>
            }
          </GridPDFExport>

        </TabStripTab>

        <TabStripTab title="Documentos">

          <ExcelExport
            fileName='Resultado_DocumentosAcoes'
            data={documentosacoes}
            ref={(exporter) => {
              setExcelExport(exporter)
            }}

          >
            <Grid className={styles.formResultadoTabs}
              sortable={true}
              onDataStateChange={dataStateChangeDocumentos}
              data={dataResultDocumentos.data.length > 0 ? dataResultDocumentos : documentosacoes.map((documentos: any) => ({
                              ...documentos,
                              data_publicacao: documentos?.data_publicacao ? format(new Date(documentos.data_publicacao), 'dd/MM/yyyy') : undefined
                            })).slice(page.skip, page.take + page.skip)
                          }
              {...dataState}
              pageable={{
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
              }}
              //groupable={true}
            >
              <GridColumn cell={documentoCustomCell} width={86} />
              {columnsDocuments?.columns?.map((column: { show: any; field: string | undefined; width: string | number | undefined; title: string | undefined; }, i: React.Key | null | undefined) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} width={column.width} title={column.title} />
              )
            );
          })}
            </Grid>

          </ExcelExport>

          <GridPDFExport
            fileName='Resultado_Documentos_Acao'
            ref={(element) => {
              setPdfExport(element);
            }}
            margin="1cm"
          >
            <Grid className={styles.formResultadoTabs}
              sortable={true}
              onDataStateChange={dataStateChangeDocumentos}
              data={dataResultDocumentos.data.length > 0 ? dataResultDocumentos : documentosacoes.map((documentos: any) => ({
                ...documentos,
                data_publicacao: documentos?.data_publicacao ? format(new Date(documentos.data_publicacao), 'dd/MM/yyyy') : undefined
              })).slice(page.skip, page.take + page.skip)
            }
              {...dataState}
              pageable={{
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
              }}
              //groupable={true}
            >

              <GridColumn field="id" width={70} title="ID" />
              <GridColumn
                field="filedoc_cod"
                width={190}
                title="ID Documento Filedoc"
              />
              <GridColumn
                field="data_publicacao"
                width={150}
                title="Data publicação"
              />
              <GridColumn
                field="tipoRecurso.designacao"
                width={150}
                title="Tipo de recurso"
              />
              <GridColumn field="titulo" width={90} title="Título" />
              <GridColumn field="autores" width={90} title="Autor" />
              <GridColumn field="entidade.nome" width={300} title="Entidade" />
              <GridColumn field="estado_id" width={"auto"} title="Estado" />
            </Grid>

          </GridPDFExport>

        </TabStripTab>
      </TabStrip>
      {openForm && (
        <Dialog
        className="ModalDocumentos"
          title={`Documento: ${idDoDocumento}`}
          onClose={close}
          style={{ zIndex: 999 }}
        >
          
            <ImagePreviewV2
              documentUrl={urlDoDocumento}
              next={(e: any) => nextPhoto(e)}
              previous={(e: any) => previousPhoto(e)}
            />

        </Dialog>
      )}
      <div className={clsx(styles.footer, styles.justify_one_child, isCurrentViewMaximized && commonStyles.maximizedFooter)}>
        <Button
          className={styles.btnPesquisar}
          onClick={clearSearchResults}
          title='Nova Pesquisa'
        >
          <span className="icon-siarl icon-pesquisar"></span>
          <span className={styles.rotulo}>
            {' '}&nbsp;{' '}
            Nova pesquisa
          </span>
        </Button>

      </div>

    </div>
  );
}